export default __webpack_public_path__ + "static/media/crypto_1_11zon.502afc2b.png";